import { useQuery } from "@tanstack/react-query";
import { getSubscriptionOverview } from "@/app/actions/subscription/get/action";
import { QueryKey } from "@/app/vars/QueryKeys";

export function useFetchSubscription(options: { enabled?: boolean } = {}) {
  const { enabled = true } = options;

  return useQuery({
    queryKey: [QueryKey.SUBSCRIPTION],
    queryFn: () => getSubscriptionOverview(),
    enabled,
    staleTime: Infinity,
  });
}
